import { Reveal, ChapterTag } from "./motion";
import { useStore } from "../../context/StoreContext";

export const Problem = () => {
  const { config } = useStore();
  const media = config?.media || {};
  const cards = [
    { img: media.problem_sofa, label: "The sofa" },
    { img: media.problem_clothes, label: "Your black clothes" },
    { img: media.problem_car, label: "The car seat" },
  ];
  return (
    <section id="problema" data-testid="problem-section" className="py-16 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="02" label="The problem" />
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl text-balance">
            If you have a pet, you know this scene.
          </h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((card, i) => (
            <Reveal key={card.label} delay={i * 0.12}>
              <figure className="group" data-testid={`problem-card-${i}`}>
                <div className="overflow-hidden rounded-2xl aspect-[4/3] bg-zinc-100 transition-transform duration-500 group-hover:scale-[1.01]">
                  {card.img && (
                    <img
                      src={card.img}
                      alt={card.label}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  )}
                </div>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="font-mono-brand text-xs text-brand">0{i + 1}</span>
                  <span className="font-display font-semibold">{card.label}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-12 text-lg sm:text-xl text-zinc-500 font-display max-w-xl leading-relaxed">
            You vacuum. You clean. And a few hours later the hair is everywhere again.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
